import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=09556ad6&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09556ad6')) {
      api.createRecord('09556ad6', component.options)
    } else {
      api.reload('09556ad6', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=09556ad6&", function () {
      api.rerender('09556ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wYZKiNAwh7we/JS/comp/ImgFallback2.vue"
export default component.exports